export interface HandsFreePopupSelection {
  questionId: string | null;
  value: string;
}

export function getNextHandsFreePopupSelection(
  prev: HandsFreePopupSelection,
  activeQuestionId: string | null
): HandsFreePopupSelection {
  if (prev.questionId === activeQuestionId) return prev;
  return { questionId: activeQuestionId, value: '' };
}

export function getHandsFreePopupSelectionValue(
  selection: HandsFreePopupSelection,
  activeQuestionId: string | null
): string {
  return selection.questionId === activeQuestionId ? selection.value : '';
}
